import { combineReducers } from 'redux';
import app from './app';
import equipmentFilter from './equipmentFilter';
import equipmentGrouping from './equipmentGrouping';
import equipmentTags from './equipmentTags';
import equipment from './equipment';
import loading from './loading';
import pageInfo from './pageInfo';
import sites from './sites';
import siteFilter from './siteFilter';
import spaces from './spaces';
import sensors from './sensors';
import notifications from './notifications';
import user from './user';
import { USER_LOGOUT } from '../actions/user';

const appReducer = combineReducers({
  app,
  equipment,
  equipmentFilter,
  equipmentGrouping,
  equipmentTags,
  loading,
  notifications,
  pageInfo,
  sites,
  siteFilter,
  spaces,
  sensors,
  user,
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
